import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Select } from '@etherisc/ui-kit';
import { apiClient } from '../../services/api';
import type { CostCenter } from '../../types/Insurance';

interface CostCenterSelectProps {
  label: string;
  value?: string;
  onChange: (costCenterId: string) => void;
  clientId?: string; // Optional filter by client
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
}

export const CostCenterSelect: React.FC<CostCenterSelectProps> = ({ 
  label, 
  value, 
  onChange, 
  clientId,
  placeholder = "Select policy/cost center...",
  disabled = false,
  required = false
}) => {
  const { data: costCenters, isLoading, error } = useQuery({
    queryKey: ['cost-centers', clientId],
    queryFn: (): Promise<CostCenter[]> => apiClient.getCostCenters(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false
  });

  if (error) {
    console.error('Failed to load cost centers:', error);
  }

  // Filter cost centers by client if needed (future enhancement)
  const filteredCostCenters = costCenters || [];

  const options = [
    { value: 'none', label: placeholder },
    ...filteredCostCenters.map(costCenter => ({
      value: costCenter.id,
      label: `${costCenter.name} (${costCenter.code})`
    }))
  ];

  return (
    <Select 
      label={label}
      value={value || 'none'}
      onValueChange={(val) => onChange(val === 'none' ? '' : val)}
      disabled={disabled || isLoading}
      required={required}
      options={options}
    />
  );
};
